import { initializeDatadog } from './src/shared/utilities/dataDog';

// Next.js runs this before the application becomes interactive, so the first
// Home API request is eligible for trace injection.
initializeDatadog();
